<p-toast></p-toast>
<div *ngIf="groupBooking" class="main-container" [formGroup]="groupForm">
    <div class="left-container" [formGroup]="generalForm">
        <div class="group-name-update-button-container">
            <div>
                <span>Group name: </span>
                <input pInputText formControlName="groupName">
            </div>
            <div>
                <p-button (onClick)="updateBookingGroup()" label="Save Change"></p-button>
            </div>
        </div>
        <div>
            <span>Bookings: </span>
            <span>{{groupBooking.bookings.length}}</span>
        </div>
        <div class="booking-list-container">
            <div>
                <p-table [value]="groupBooking.bookings">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>
                                ID
                            </th>
                            <th>
                                Last name
                            </th>
                            <th>
                                First name
                            </th>
                            <th>
                                From
                            </th>
                            <th>
                                To
                            </th>
                            <th>
                                School
                            </th>
                            <th>
                                Destination
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-booking>
                        <tr>
                            <td>
                                <span *ngIf="booking.lvmsId">
                                    {{booking.lvmsId}}
                                </span>
                                <span *ngIf="!booking.lvmsId">
                                    {{booking.id}}
                                </span>
                            </td>
                            <td>
                                {{booking.student.lastName}}
                            </td>
                            <td>
                                {{booking.student.firstName}}
                            </td>
                            <td>
                                {{booking.startDate | date: 'dd/MM/yyyy'}}
                            </td>
                            <td>
                                {{booking.endDate | date: 'dd/MM/yyyy'}}
                            </td>
                            <td>
                                {{booking.schoolName}}
                            </td>
                            <td>
                                {{booking.destination}}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>



    </div>
    <div class="right-container">
        <div class="guide-list-container">
            <div>
                Accompanist
            </div>
            <p-table [value]="accompanistForm.controls">
                <ng-template pTemplate="header">
                    <tr>
                        <th [style]="{'width': '100px'}">lastname</th>
                        <th [style]="{'width': '100px'}">firstname</th>
                        <th [style]="{'width': '90px'}">phone</th>
                        <th [style]="{'width': '100px'}">email</th>
                        <th [style]="{'width': '100px'}">accommodation</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-form let-index="rowIndex">
                    <tr [formGroup]="form">
                        <td>
                            <input pInputText formControlName="lastName" class="form-input">
                        </td>
                        <td>
                            <input pInputText formControlName="firstName" class="form-input">
                        </td>
                        <td>
                            <input pInputText formControlName="phoneNumber" class="form-input">
                        </td>
                        <td>
                            <input pInputText formControlName="email" class="form-input">
                        </td>
                        <td>
                            <input pInputText formControlName="address" class="form-input">
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="footer">
                    <tr class="no-record-tr">
                      <td colspan="5">
                        <div class="no-record-row" (click)="addEmptyAccompanistForm()">
                          <p class="no-record-message">
                            Add record
                          </p>
                          <div class="icon-wrap">
                            <i class="pi pi-plus"></i>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </ng-template>
            </p-table>
        </div>
    </div>
</div>